// import donkey from './flatbuffers/flexbuffers.js';

import {StreamSession} from "./stream-session.js";

let LastStreamSession = null;

export function StopListening() {
	if (LastStreamSession != null) {
		LastStreamSession.StopListen();
		LastStreamSession = null;
	}
}

export function StartListening(source, canvasroot) {
	if (LastStreamSession != null) {
		LastStreamSession.StopListen();
		LastStreamSession = null;
	}

	LastStreamSession = new StreamSession(source, canvasroot);
	LastStreamSession.StartListen();
}
